<template>
  <div>
      <div class="col-md-8 col-md-offset-2" v-if="view">
        <transition name="fade">
          <div v-if="!reviewedSitecode">
            <SiteSelection type="Registration" ref="SiteSelection" @disabledSubmitButton="disabledSubmitButton" :siteCodeCaption="currentRouteName === '/patient/register' ? 'Office Location Code' : 'Enter your zip code as office location code'">
            </SiteSelection>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="reviewedSitecode">
            <MedicationData type="Registration" ref="MedicalData" :triggerWatch="true">
            </MedicationData>
          </div>
        </transition>
        <br />
        <transition name="fade">
        <div v-if="reviewedSitecode">
          <BillSection ref="BillSection" v-if="allow_billing"> </BillSection>
        </div>
        </transition>
        <div v-if="reviewedSitecode">
         <ConsentDisclaimer :submit="submit" ref="ConsentDisclaimer" />
        </div>
        <div v-if="reviewedSitecode && (($store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && $store.state.insuranceType === 'cash' && $store.state.cashPayment === 'card') || $store.state.configs['AT_HOME_COLLECTION'] === true)"> <payment-section ref="paymentSectionVisible"></payment-section></div>
        <br>
        <ScheduleSection v-if="reviewedSitecode && this.$store.state.site.schedule.data.length && this.$store.state.configs.ALLOW_SCHEDULES" ref="ScheduleSection" />
        <br/>
        <transition name="fade">
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <small class="text-danger" v-if="errorSave"">
                {{ computeCaption(errorSave, $store.state.lang.value.toLowerCase()) }}
              </small>
            </div>
          </div>
        </transition>
        <div class="row">
          <div class="col-md-10 col-md-offset-1 button-container">
            <button
              class="btn btn-default btn-wd btn-back primary-color back-button"
              v-on:click.stop.prevent="
                $router.push({ path: '/' })
              "
            >
              <span> {{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}</span>
            </button>
            <button v-if="reviewedSitecode"
                    class="btn btn-fill btn-wd btn-next float-right next-button"
                    v-on:click.stop.prevent="callValidation()"
                    :disabled="disabledButton === true"
            >
              <span v-if="disabledButton === false">{{computeCaption(fields_en['register'], $store.state.lang.value.toLowerCase())}}</span>
              <span v-else>{{computeCaption(fields_en['submitting'], $store.state.lang.value.toLowerCase())}}</span>
            </button>
            <button v-if="!reviewedSitecode"
                    class="btn btn-fill btn-wd btn-next float-right next-button"
                    v-on:click.stop.prevent="callSiteValidation()"
                    :disabled="disabledButton === true"
            >
              <span v-if="disabledButton === false"> {{computeCaption(fields_en['next'], $store.state.lang.value.toLowerCase())}}</span>
              <span v-else>{{computeCaption(fields_en['submitting'], $store.state.lang.value.toLowerCase())}}</span>
            </button>
          </div>
        </div>
        <br /><br />
      </div>
      <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>
/* eslint-disable */
  import {mapFields} from 'vee-validate'
  import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import MedicationData from '../Wizard/MedicationDataStep'
  import SiteSelection from '../Wizard/SiteSelectionStep.vue'
  import swal from 'sweetalert2'
  import ConsentDisclaimer from '../../Utils/Sections/ConsentDisclaimer.vue'
  import VueBarcode from 'vue-barcode'
  import PaymentSection from '../../Utils/Sections/PaymentSection'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {PatientInfoUtils} from '../../../../../utils/PatientInfo'
  import BillSection from '../../Utils/Sections/BillSection'
  import ScheduleSection from '../../Utils/Sections/ScheduleSection'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      ScheduleSection,
      BillSection,
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Drawer.name]: Drawer,
      [RadioButton.name]: RadioButton,
      [CheckboxButton.name]: CheckboxButton,
      [CheckboxGroup.name]: CheckboxGroup,
      MedicationData,
      SiteSelection,
      ConsentDisclaimer,
      'barcode': VueBarcode,
      PaymentSection
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, PatientInfoUtils],
    data () {
      return {
        submittingRegistration: false,
        currentRouteName: '',
        view: false,
        redirectUrl: '',
        confirmationNumber: '',
        disabledButton: false,
        sitecode: '',
        sitecodeError: '',
        sitecodeMessage: '',
        signature: '',
        submit: false,
        reviewedSitecode: false,
        finalResponse: {},
        dependentError: '',
        optionsArray: [{name: 'Self'}],
        suggestions: [],
        answers_es: {},
        answers_zh: {},
        requirements: [],
        questionError: '',
        errorDate: '',
        errorSave: '',
        client_bill_translation: '',
        questionErrorDate: [],
        answer_no: 'No',
        amount: this.$store.state.configs.PAYMENT_AMOUNT,
        allow_payment: this.isTrue(this.$store.state.configs.ALLOW_PAYMENT),
        allow_insurance_card: this.isTrue(this.$store.state.configs.ALLOW_INSURANCE_CARD),
        required_insurance_card: this.isTrue(this.$store.state.configs.REQUIRED_INSURANCE_CARD),
        allow_above_medication_text: this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT,
        fields_en: {
          if_you_can_not_sign: this.$store.state.configs.DISCLAIMER_NAME_TEXT || 'If you can not sign using the signature panel above, please type your full name as your signature here',
          submitting: 'Submitting... please wait',
          next: 'Next',
          office_location_code: 'Office Location Code',
          back: 'Back',
          register: 'Register',
          client_bill: 'Client Bill',
          select_payment_type: 'Select Payment Type',
          insurance: 'Insurance',
          uninsured: 'Uninsured',
          cash: 'Cash',
          please_provide_payment_information: 'Please Provide Payment Information',
          primary_insurance_name: 'Primary Insurance Name',
          policy_number: 'Policy Number',
          group_number: 'Group Number',
          insurance_card: 'Insurance Card',
          patient_relationship_to_insured: 'Patient Relationship to Insured',
          note: 'Note',
          after_registration_you_will_be_redirected_to_a_payment_page: 'After registration you will be redirected to a payment page',
          social_security_number: 'Social Security Number',
          driver_license_number: 'Driver License Number',
          patient: 'Select patient',
          please_answer_to_the_best_of_your_knowledge: 'Please answer to the best of your knowledge',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required'
        },
        model: {
          note: ''
        },
        modelValidations: {
        }
      }
    },
    created () {
      if (window.location.href.includes('/patient/order') && this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false) {
        this.view = false
        window.location.href = window.origin + '/#/patient/register'
        window.location.reload()
      } else {
        this.view = true
      }
    },
    methods: {
      redirectHome () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.href = window.origin + '/#/'
          window.location.reload()
        }
      },
      redirectConfirmationNumberPage () {
        if (this.$store.state.redirect_registration_url && this.$store.state.redirect_registration_url.includes('{{')) {
          let redirectUrl = this.$store.state.redirect_registration_url
          redirectUrl = redirectUrl.replace('site_code', this.$store.state.site.code)
          redirectUrl = redirectUrl.replace('confirmation_number', this.confirmationNumber)
          redirectUrl = redirectUrl.replace('first_name', this.$store.state.dataForInsurance.first_name)
          redirectUrl = redirectUrl.replace('last_name', this.$store.state.dataForInsurance.last_name)
          redirectUrl = redirectUrl.replaceAll('{{', '')
          redirectUrl = redirectUrl.replaceAll('}}', '')
          this.redirectUrl = redirectUrl
        } else {
          if (this.$store.state.redirect_registration_url) {
            this.redirectUrl = ''
          } else {
            this.redirectUrl = ''
          }
        }
      },
      makeButtonDisabled () {
        this.disabledButton = true
      },
      async callValidation () {
        let info = await this.getPatientInfo()
        let ValidateDisclaimerConsent = await this.$refs.ConsentDisclaimer.validate()
        this.signature = this.$store.state.consentSignature
        let ScheduleSection
        if (this.$store.state.site.schedule.data.length && this.$store.state.configs.ALLOW_SCHEDULES) {
          ScheduleSection = await this.$refs.ScheduleSection.validate()
        } else {
          ScheduleSection = true
        }
        this.submit = true
        this.finalResponse = {}
        await this.$refs.MedicalData.validate()
        this.$store.state.insuranceValidator = true
        if (this.allow_billing && !await this.$refs.BillSection.validate()) {
          return
        }
        if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash' && this.$store.state.cashPayment === 'card') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
          let ValidatePayment = await this.$refs.paymentSectionVisible.validate()
          if (ValidatePayment.valid !== false) {
            this.finalResponse = {...this.finalResponse, ...ValidatePayment}
          } else {
            return false
          }
        }
        if ((await this.$validator.validateAll() === true) && ScheduleSection && ValidateDisclaimerConsent && this.$store.state.insuranceValidator && this.$store.state.medDataValidator) {
          this.finalResponse = {...this.finalResponse, ...this.$store.state.currentData}
          this.finalResponse.appointment_date = ScheduleSection.appointment_date
          this.finalResponse.appointment_slot_id = ScheduleSection.appointment_slot_id
          this.finalResponse.questions = this.$store.state.questions
          this.finalResponse['paid_cash'] = this.$store.state.cashPayment
          this.finalResponse['redirect_payment_url'] = this.$store.state.redirect_payment_url
          this.finalResponse.signature = this.signature
          this.finalResponse.siteCode = this.$store.state.sitecode
          this.finalResponse.patient_support_info = this.$store.state.configs.PATIENT_SUPPORT_INFO
          this.finalResponse = {...this.finalResponse, ...this.$store.state.registrationInsuranceData}
          this.finalResponse.info = info
          this.disabledButton = true
          const self = this
          this.errorSave = ''
          if (this.submittingRegistration) {
            return
          }
          this.submittingRegistration = true
          axios
            .post(process.env.SERVER_URI + '/register/' + this.$store.state.site.code, this.finalResponse)
            .then((response) => {
                if (response.data.schedule) {
                  swal({
                    html: `<h4>` + response.data.schedule + `</h4>
                           <br>`,
                    icon: 'error',
                    type: 'error',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    showConfirmButton: true,
                    width: 700
                  })
                  this.disabledButton = false
                  return
                }
                if (response.data === false) {
                  this.disabledButton = false
                  this.errorSave = 'There was an error submitting the data'
                } else {
                  if (response.data['template'] === undefined && response.data.includes('card')) {
                    swal('Error!', response.data, 'error')
                    self.redirect()
                    return
                  }
                  if (response.data['template'] === undefined) {
                    swal('Error!', 'There was an error submitting the data', 'error')
                    self.redirect()
                    return
                  }
                  if (this.$store.state.cashPayment && (this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === false && this.$store.state.configs['AT_HOME_COLLECTION'] === false)) {
                    // redirect to custom payment
                    if (this.$store.state.redirect_payment_url) {
                      window.location.href = this.$store.state.redirect_payment_url + response.data['confirmation_number']
                    } else {
                      this.$router.push({ name: 'PaymentWizard', params: {id: response.data['confirmation_number']}, query: {lang: this.$store.state.lang.value} })
                    }
                  } else {
                    this.confirmationNumber = response.data['confirmation_number']
                    let template = response.data['template']
                    let url = this.$store.state.redirect_registration_url
                    let redirectUrl = this.redirectUrl
                    let langValue = this.$store.state.lang.value
                    if (this.$store.state.redirect_registration_url && this.$store.state.redirect_registration_url.includes('{{')) {
                      this.redirectConfirmationNumberPage()
                      setTimeout(() => {
                        swal({
                          html: template + `
                               </b>
                           <br>
                           <div class="flex">
                          <button type="button" style="background: #51A7E9" class="btn-modal btn-complete">` + this.computeCaption('Complete', this.$store.state.lang.value.toLowerCase()) + `</button>
                          <button type="button" style="background: #79c5c5" class="btn-modal btn-new-patient">` + this.computeCaption('Register New Patient', this.$store.state.lang.value.toLowerCase()) + `</button>
                          </div>`,
                          showCancelButton: false,
                          showConfirmButton: false,
                          width: 700,
                          onBeforeOpen: () => {
                            const complete = document.querySelector('.btn-complete')
                            const patient = document.querySelector('.btn-new-patient')

                            complete.addEventListener('click', () => {
                              let urlTemp = window.origin + '/#/?lang=' + langValue
                              window.location.assign(urlTemp)
                              window.location.reload()
                              swal.close()
                            })

                            patient.addEventListener('click', () => {
                              let urlTemp = window.origin + '/#/patient/order?lang=' + langValue + '&site_code=' + this.$store.state.sitecode
                              window.location.assign(urlTemp)
                              window.location.reload()
                              swal.close()
                            })
                          }
                        }).catch(swal.noop)
                      }, 1000)
                    } else {
                      this.redirectConfirmationNumberPage()
                      setTimeout(() => {
                        swal({
                          html: template + `
                               </b>
                           <br>
                           <div class="flex">
                          <button type="button" style="background: #51A7E9" class="btn-modal btn-complete">` + this.computeCaption('Complete', this.$store.state.lang.value.toLowerCase()) + `</button>
                          <button type="button" style="background: #79c5c5" class="btn-modal btn-new-patient">` + this.computeCaption('Register New Patient', this.$store.state.lang.value.toLowerCase()) + `</button>
                          </div>`,
                          showCancelButton: false,
                          showConfirmButton: false,
                          width: 700,
                          onBeforeOpen: () => {
                            const complete = document.querySelector('.btn-complete')
                            const patient = document.querySelector('.btn-new-patient')

                            complete.addEventListener('click', () => {
                              if (redirectUrl === '' && url) {
                                url = url + '?lang=' + langValue
                                window.location.assign(url)
                                window.location.reload()
                              } else {
                                let urlTemp = window.origin + '/#/?lang=' + langValue
                                window.location.assign(urlTemp)
                                window.location.reload()
                              }
                              swal.close()
                            })

                            patient.addEventListener('click', () => {
                              let urlTemp = window.origin + '/#/patient/order?lang=' + langValue + '&site_code=' + this.$store.state.sitecode
                              window.location.assign(urlTemp)
                              window.location.reload()
                              swal.close()
                            })
                          }
                        }).catch(swal.noop)
                      }, 1000)
                    }
                  }
                }
              })
            .catch(error => {
                this.disabledButton = false
                console.log(error)
                this.errorSave = 'There was an error submitting the data'
              })
            .finally(() => {
              this.submittingRegistration = false
            })
        } else {
          this.errorSave = 'One of the above fields was not completed properly'
        }
      },
      async callSiteValidation () {
        await this.makeButtonDisabled()
        let validateSiteCode = await this.$refs.SiteSelection.validate()
        if (validateSiteCode) {
          this.reviewedSitecode = true
          this.disabledButton = false
        } else {
          this.reviewedSitecode = false
          this.disabledButton = false
        }
      },
      disabledSubmitButton (booleanValue) {
        this.disabledButton = booleanValue
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      redirect () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.reload()
        }
      }
    },
    computed: {
      ...mapFields(['dependent', 'questions']),
      allow_billing () {
        return this.$store.state.configs.ALLOW_BILLING
      }
    },
    watch: {
      '$store.state.allCallsDone': {
        handler (before, after) {
          this.reviewedSitecode = true
        },
        deep: true
      },
      '$store.state.invalidSiteCode': {
        handler (before, after) {
          if (this.$store.state.invalidSiteCode === true) {
            this.disabledButton = false
          }
        },
        deep: true
      }
    },
    beforeMount () {
      if (!window.location.href.includes('/patient/order-home-collection')) {
        this.currentRouteName = '/patient/register'
      } else {
        this.currentRouteName = '/patient/order-home-collection'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";
.mt-10 {
  margin-top:10px;
}
.el-select--large {
  width: 100%;
}

.el-autocomplete {
  width: 100%;
}

>>>.el-drawer.rtl {
  overflow-y: scroll !important;
}

h4 {
  margin-bottom: 15px;
  font-weight: normal;
}
.display-none {
  display: none;
}

.generic-answer {
  margin-top: 10px;
}

.float-right {
  float: right;
}

.p-0 {
  padding: 0;
}

.w-100 {
  width: 100% !important;
}

.pr-0 {
  padding-right: 0;
}

.p-10 {
  padding: 10px;
}

.pt-10 {
  padding-top: 10px;
}

.d-inline-block {
  display: inline-block;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.upload-file {
  width: 0;
  height: 0;
}

.upload-file-label {
  display: block;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
}

.elipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  height: 1.2em;
  white-space: nowrap;
}

.text-none {
  text-transform: none;
  font-size: 14px;
}

@media screen and (max-width: 991px) {
  .pr-0 {
    padding-left: 0;
  }

  .mt-5 {
    margin-top: 0;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .button {
    float: left;
    width: 100% !important;
  }

  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}
@media screen and (max-width: 420px) {
  .button-container {
    display: grid;
  }
  .button-container > .back-button{
    grid-row: 2 !important;
  }
  .button-container > .next-button{
    grid-row: 1 !important;
  }
}
@media screen and (max-width: 365px) {
  >>> .el-radio-button--small .el-radio-button__inner {
    padding: 9px 7px;
  }
  .button {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/SinglePage/Register.vue